<div class="landscape_inner_border">
    Players on-line:
    <div class="highlight">1680</div>
</div>
